// The roles of the previous ANNA dashboard (anna_config.json, exported 2026-10-05), as its builder set
// them up: each role's own questions (asked as written), which interview blocks it uses, and its
// personality. Cleaned only: typos fixed, and questions the shared blocks already ask taken out
// ("Tell me about yourself", the weaknesses, DeskTime, the work-history walk, availability).
// Personality (David's phase 3) is on for every role. A vacancy's Interview section can start from one.
export const DASHBOARD_ROLES = [
  {
    role: 'AI Developer',
    personality: 'Friendly-Standard',
    blocks: {
      opening: true,
      resume: true,
      deepDive: true,
      role: true,
      screening: true,
      ending: false,
    },
    roleQuestions: [
      'What do you know about our company and what we do?',
      'Are you comfortable working remotely?',
      "Could you tell me about an AI project you've worked on that you're especially proud of? What was your specific role and contribution, is the project in use today, and did you work on it alone or as part of a team?",
      'What programming languages and frameworks do you usually use in your AI projects?',
      'Tell me about a technical challenge you encountered while developing an AI solution. What caused the problem, and how did you personally resolve it?',
      'How do you usually handle multiple priorities or tight deadlines?',
      'How familiar are you with Claude?',
      'What would you consider your strongest professional quality?',
    ],
  },
  {
    role: 'Sales and Marketing',
    personality: 'Formal-Professional',
    blocks: {
      opening: true,
      resume: false,
      deepDive: true,
      role: true,
      screening: true,
      ending: true,
    },
    roleQuestions: [
      'Can you walk me through your experience in B2B sales and the types of products or services you have sold?',
      'Imagine you are given a new product with no existing leads. What would you do during your first week to build a sales pipeline?',
      'How do you qualify a lead before deciding how much time to invest in that prospect?',
      'What experience do you have with email marketing, and how do you improve email open and response rates?',
      'What role do you believe social media should play in a B2B sales strategy?',
      'How have you personally used AI or LLMs in your sales or marketing work?',
      'Can you describe one real business problem you solved using an LLM such as Claude or ChatGPT?',
      'Imagine you have 500 potential leads. How would you use AI to research, qualify, prioritize, and personalize outreach to those leads?',
      'You have 1,000 leads, a CRM, Claude, and an email platform. How would you combine these tools to create an automated lead-generation and follow-up process?',
      'What is one AI workflow you have personally built or implemented? Please explain the steps from beginning to end.',
    ],
  },
  {
    role: 'SaaS Automotive Sales Professional',
    personality: 'Friendly-Standard',
    blocks: {
      opening: true,
      resume: true,
      deepDive: true,
      role: true,
      screening: true,
      ending: true,
    },
    roleQuestions: [
      'Can you briefly describe your experience selling SaaS or digital solutions to automotive businesses?',
      'Do you have experience using CRM systems in your previous sales roles?',
      'Which CRM systems have you used, and how did you use them to manage leads, follow-ups, and your sales pipeline?',
      'How do you approach a cold call to a new dealership and work toward securing a sales meeting?',
      "How would you identify a dealership's pain points and show how your SaaS solution can address them?",
      "Do you have a valid driver's license and access to a vehicle for work-related travel?",
    ],
  },
  {
    role: 'Support Specialist',
    personality: 'Friendly-Standard',
    blocks: {
      opening: true,
      resume: true,
      deepDive: true,
      role: true,
      screening: false,
      ending: true,
    },
    roleQuestions: [
      'Do you have experience working with AI-driven products or systems, products for customers that include AI features? If so, how have you supported users interacting with them?',
      'How do you handle a difficult or frustrated customer?',
      'How do you prioritize multiple support requests at once?',
      'How do you explain a technical issue to a non-technical customer?',
      'Tell me about a time you solved a customer problem under pressure.',
      'How do you make sure you follow up on unresolved issues?',
      'What CRM or support ticketing tools have you used before?',
      'How would you troubleshoot a customer who cannot access a web application?',
      'How would you troubleshoot a slow or unstable internet connection?',
    ],
  },
];
